<template>
  <v-dialog v-model="dialog" width="450">
    <v-card class="pt-1">
      <v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn x-small text @click="$emit('close-dialog')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-chip
          :color="translateCategoryJa(information.category).color"
          label
          small
        >
          {{ translateCategoryJa(information.category).label }}
        </v-chip>
        <span style="float: right">
          {{ information.notificationStartAt | momentDateTime }}
        </span>
        <p class="mt-3" style="font-size: 20px; color: black">
          {{ information.title }}
        </p>
        <p class="mt-2">{{ information.content }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import formatUtils from '@/mixins/format_utils'
import systemInformationUtils from '@/mixins/system_information_utils'

export default {
  name: 'SystemInformationDetailDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    information: {
      type: Object,
      required: true
    }
  },
  mixins: [formatUtils, systemInformationUtils]
}
</script>
